import React, {useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Container, Row, Col, Button } from 'react-bootstrap';
import Labels from '../translations/translation.json'
import Header from '../../layouts/header';
import './emailVerification.css';
import Footer from '../../layouts/footer/footer';
import {languageCodeMapper} from '../space/translationCodeMapper';
import Loader from '../../layouts/loader/index';
import apiConfig from '../trustBuilder/Auth/services/apiConfig';
import { SERVER } from '../../constants/networkUrls';
import axios from 'axios';


function EmailVerification(props) {
    let pathName = window.location.pathname;
    let pathNameObjArray = pathName.split("/");
    const [langCode, setlangCode] = useState(languageCodeMapper(pathNameObjArray[3]));
    const [loadingStatus,setLoadingStatus] = useState(true);
    const [isLinkExpired,setIsLinkExpired] = useState(false);
    const [isResendLink,setIsResendLink] = useState(false);
    const [incidentNumber,setIncidentNumber] = useState("");
    const [statusCode,setStatusCode] = useState(0);
    let isFMO = props.isFMO;
    document.title = isFMO ? "FixMyOffice - Incident" : "FixMyStation - Incident"

    const hostname = window && window.location && window.location.hostname;
	const environmentConstants = apiConfig.setEnvironmentURLs(hostname);

   useEffect(()=>{
    const apiUrl = `${SERVER.API_BASE_URL}${SERVER.SERVICES.FMS_VERIFY_EMAIL}`;
    verifyEmailAPI(apiUrl);
   },[])


   const resendEmailAPI = (apiUrl) => {  
    setIsLinkExpired(false) 
    let authConfig = {
            headers:{
                "X-API-KEY" : environmentConstants.apiKey
            }
        }
    
    console.log("apiURL",apiUrl); 
    console.log("verification Token",pathNameObjArray[5]); 
        const verifyRequestBosy = {
            "verificationToken": pathNameObjArray[5],
          }
        axios.post(apiUrl, verifyRequestBosy,authConfig).then((response) =>{
            console.log("response of verificationEmail Response only",response);
            setLoadingStatus(false);
            setStatusCode(response.status)
            setIsResendLink(true);
        }).catch(error => {
            setLoadingStatus(false);
            setIsResendLink(true);
            setStatusCode(error.response.status)
            console.log("error",error.response.status); 
        })
    }

   const verifyEmailAPI = (apiUrl) => {   
    setIsResendLink(false);
    let authConfig = {
            headers:{
                "X-API-KEY" : environmentConstants.apiKey
            }
        }
    
    console.log("apiURL",apiUrl); 
    console.log("verification Token",pathNameObjArray[5]); 
        const verifyRequestBosy = {
            "verificationToken": pathNameObjArray[5],
          }
        axios.post(apiUrl, verifyRequestBosy,authConfig).then((response) =>{
            console.log("response of verificationEmail Response only",response);
            setLoadingStatus(false);
            setStatusCode(response.data.verificationStatus)
            if(response.data.verificationStatus === 200) {
                setIsLinkExpired(false);
                setIncidentNumber(response.data.incidentNumber);
              } else if (response.data.verificationStatus === 409){
                setIsLinkExpired(true);
              }
        }).catch(error => {
            console.log("verifyEmail error",error);
            setLoadingStatus(false);
            setStatusCode(error.response.status)
            setIncidentNumber(error.response.data.incidentNumber);
            if(error.response.status === 409){
                setIsLinkExpired(true);
            }else{
                setIsLinkExpired(false);
            }
            console.log("error",error.response.status); 
        })
    }

  
    const resendEmailLink = () => {
        setLoadingStatus(true);
        const apiUrl = `${SERVER.API_BASE_URL}${SERVER.SERVICES.FMS_RESEND_VERIFY_LINK}`;
        resendEmailAPI(apiUrl);  
    }
   
    const handledropdownLang = (e) => {
        setlangCode(e.target.value);
		console.log("langCode in handleDropdown in submittedPage.js : ",langCode);
	}

    const textChanges = () => {
        console.log("status code in textChanges",statusCode);
        const successMessage = `${Labels[langCode].EMAIL_VERIFICATION_SUCCESS} ${incidentNumber}.`
        const errorMessage = Labels[langCode].EMAIL_VERIFICATION_COMPLETED
        const notFoundMessage = Labels[langCode].EMAIL_NOT_FOUND
        console.log("status code and incidentNumber",statusCode,incidentNumber)
        if(statusCode === 200){
            return successMessage
        } else if(statusCode === 400 && incidentNumber != null){
            return errorMessage;
        } else if(statusCode === 400 && incidentNumber == null){
            return notFoundMessage;
        }
        else{
            return notFoundMessage;
        }
    }

    
    return(
        <>
            <Header langCode={langCode}
                isPrivate={isFMO}
                handledropdown={handledropdownLang} />
            {loadingStatus === false ? <Container fluid className="main-container">
            <Row>
                <Col xl={3} lg={3} md={3} sm={0} xs={0} xxs={0}>
                    <div>
                    </div>
                </Col>
                <Col xl={6} lg={6} md={6} sm={12} xs={12} xxs={12} className="subMain-container">
                    {isLinkExpired && !isResendLink ? <Container fluid className="content-container">
                        <Row>
                        <Col lg={12} md={12} sm={12} xs={12} xxs={12} className="col-conetent">
                            <span className='submitted-text1'>{Labels[langCode].EMAIL_VERIFICATION_EXPIRED_1}</span>
                            <Button role="button"  style={{fontSize : '17px'}} className="btn-gotoweb" onClick={resendEmailLink}>{Labels[langCode].RESEND_LINK}</Button>
                            <span className='submitted-text'>{Labels[langCode].EMAIL_VERIFICATION_EXPIRED_2}</span>
                            <span className='submitted-text'>{Labels[langCode].EMAIL_VERIFICATION_EXPIRED_3}</span>
                            <span className='submitted-text'>{Labels[langCode].EMAIL_VERIFICATION_EXPIRED_4}</span>
                            </Col>
                        </Row>    
                    </Container> : !isResendLink && <Container fluid className="content-container">
                        <Row>
                            <Col lg={12} md={12} sm={12} xs={12} xxs={12} className="col-conetent">
                            <p><span className='submitted-text'>{textChanges()}</span></p>
                            </Col>
                        </Row>    
                    </Container>}
                    {isResendLink && statusCode === 200 ? <Container fluid className="content-container">
                        <Row>
                        <Col lg={12} md={12} sm={12} xs={12} xxs={12} className="col-conetent">
                            <span className='submitted-text'>{Labels[langCode].RESEND_EMAIL_PARA1} 6 {Labels[langCode].RESEND_EMAIL_PARA2}</span>
                            </Col>
                        </Row>    
                    </Container> : isResendLink && <Container fluid className="content-container">
                        <Row>
                            <Col lg={12} md={12} sm={12} xs={12} xxs={12} className="col-conetent">
                            <p><span className='submitted-text'>{textChanges()}</span></p>
                            </Col>
                        </Row>    
                    </Container>}
                </Col>
               <Footer />
            </Row>    
            </Container> : <Loader/>}
        </>
    );
}

EmailVerification.propTypes = {
    isFMO: PropTypes.bool,
};

export default EmailVerification;